import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/Auth";
import { SiteFooter } from "@/components/Layout";
import { GoogleButton } from "@/components/GoogleAuth";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const m = await login(email, password, mode === "register", name);
    setBusy(false);
    if (m) setErr(m);
    else nav("/");
  };

  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      <div className="flex flex-col justify-between bg-slate-900 p-8 text-white md:w-[44%] md:p-12">
        <div className="w-fit rounded-xl bg-white px-4 py-2">
          <img src="/logo.png" alt="RingUs" data-testid="login-logo" className="h-10 w-auto" />
        </div>
        <div className="my-10 md:my-0">
          <h1 className="text-4xl font-extrabold leading-tight sm:text-5xl">Every card you collect,<br /><span className="text-teal-400">followed up.</span></h1>
          <p className="mt-4 max-w-md text-slate-300">Scan business cards and QR codes at exhibitions, review the details, and send personal introduction emails you approve — one at a time or in a batch.</p>
        </div>
        <p className="text-xs text-slate-500">Private workspace · Your contacts are visible only to you</p>
      </div>
      <div className="flex flex-1 flex-col items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm cd-fade" data-testid="login-form">
          <h2 className="text-2xl font-bold">{mode === "login" ? "Sign in" : "Create your workspace"}</h2>
          <p className="mb-6 mt-1 text-sm text-slate-500">{mode === "login" ? "Welcome back." : "One owner account per workspace."}</p>
          <GoogleButton />
          <div className="my-4 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />or with email<span className="h-px flex-1 bg-slate-200" /></div>
          {mode === "register" && (
            <input data-testid="register-name-input" className="cd-input mb-3" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} />
          )}
          <input data-testid="login-email-input" className="cd-input mb-3" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          <input data-testid="login-password-input" className="cd-input mb-3" type="password" placeholder="Password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
          {err && <p data-testid="login-error" className="mb-3 rounded-xl bg-rose-50 p-3 text-sm text-rose-700">{err}</p>}
          <button data-testid="login-submit-btn" disabled={busy} className="cd-btn-primary w-full">{busy ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"}</button>
          <button type="button" data-testid="toggle-auth-mode-btn" onClick={() => { setMode(mode === "login" ? "register" : "login"); setErr(""); }} className="mt-4 w-full text-center text-sm font-medium text-teal-700">
            {mode === "login" ? "New here? Create an account" : "Already have an account? Sign in"}
          </button>
        </form>
        <SiteFooter className="w-full max-w-sm" />
      </div>
    </div>
  );
}
